<template>
    <div>
        <Loader />
    </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import persistentData from '@/plugins/persistentData';
import Loader from '@/components/Loader.vue';

const route = useRoute();
const router = useRouter();
const store = useStore();

function getPathName(url) {
  try {
    const u = new URL(url);
    return u.pathname + u.search + u.hash; 
  } catch (e) {
    return null;
  }
}

onMounted(async()=>{
    try {
        let request = await store.dispatch('security_SSO', { access: route.query.key })
        if (request.status === 200) {
            persistentData.set('token', request.data.token);
            persistentData.set('tokenExpiration', request.data.tokenExpiration);
            persistentData.set('user', JSON.stringify(request.data));

            const retTo = getPathName(route.query.redirectTo);
            if(retTo){
                store.commit('redirectAfterLogin', retTo);
            }

            if(request.data.profiles.length === 1){
                store.dispatch('manageUser_active');
                if(retTo && retTo != '/login'){
                    router.push(retTo)
                } else{ 
                    router.push('/');
                }
            }
            else {
                router.push('/pickRole')
            }
        }
    } 
    catch (error) {
        store.dispatch('notifications_create', {text: `Credenciales de inicio de sesión inválidas`});
        router.push('/login');
    }
})
</script>